import {
  ForwardRefComponent,
  HTMLMotionProps,
  motion,
  useMotionTemplate,
  useScroll,
  useSpring,
  useTransform,
} from 'framer-motion';
import Link from 'next/link';
import { ImgHTMLAttributes, PropsWithChildren, ReactNode, useEffect, useRef } from 'react';
import styled, { DefaultTheme, StyledComponent } from 'styled-components';
import { BrandSitesV2Theme } from '../common/GlobalStyle';

export default function TeamSection() {
  return (
    <Container>
      <Wrapper>
        <Top>
          <TitleWrapper>
            <FakeTitle>인연을 이어가기 위한 청연의 노력</FakeTitle>
            <TitleDesktop>{TitleDesktopSvg}</TitleDesktop>
            <TitleTablet>{TitleTabletSvg}</TitleTablet>
          </TitleWrapper>
          <Description>
            청연팀은 더 나은 서비스 경험과 업무 환경을 제공하기 위한 목표를 가지고 있습니다. 늘 고객과 매니저를 모두
            생각하는 청연 팀의 이야기를 들려 드립니다.
          </Description>
        </Top>
        <CardGrid>
          <Link href="https://cleaninglab-official.notion.site/d8fe977becbd4e618d412371f48e3b45" passHref>
            <EducationCard target="_blank">
              <CardBackground>
                <picture>
                  <source
                    srcSet="https://cleanhome-web.cleaninglab.co.kr/brandsite/about/webp/education_card_mobile.webp"
                    type="image/webp"
                    media={`(max-width:${BrandSitesV2Theme.brandSitesV2!.breakpoints.mobile})`}
                  />
                  <source
                    srcSet="https://cleanhome-web.cleaninglab.co.kr/brandsite/about/webp/education_card.webp"
                    type="image/webp"
                  />
                  <source
                    srcSet="https://cleanhome-web.cleaninglab.co.kr/brandsite/about/education_card_mobile.png"
                    type="image/png"
                    media={`(max-width:${BrandSitesV2Theme.brandSitesV2!.breakpoints.mobile})`}
                  />
                  <source
                    srcSet="https://cleanhome-web.cleaninglab.co.kr/brandsite/about/education_card.png"
                    type="image/png"
                  />
                  <CardBackgroundImgMotion
                    CardBackgroundImage={CardBackgroundImage}
                    src="https://cleanhome-web.cleaninglab.co.kr/brandsite/about/education_card.png"
                  />
                </picture>
                <CardBlur />
              </CardBackground>
              <CardFront>
                <CardTop>
                  <CardTeam>교육팀</CardTeam>
                  <CardTitle>
                    집안일만 하던 주부도 <br /> 청소전문가 매니저로 변신!
                  </CardTitle>
                  <CardDescription>
                    만약 교육이 없다면, 고객은 매니저에 따라 다른 서비스를 받게 될거에요. 어떤 매니저가 방문해도 동일한
                    서비스를 제공해드릴 수 있도록 하는 것이 중요했어요
                    <DescriptionViewMore>... 더보기</DescriptionViewMore>
                  </CardDescription>
                </CardTop>
                <PlusButton>{PlusSvg}</PlusButton>
              </CardFront>
            </EducationCard>
          </Link>
          <Link href="https://cleaninglab-official.notion.site/15766f958fcc4ac5be40e07d5367da22" passHref>
            <PolicyCard target="_blank">
              <CardBackground>
                <picture>
                  <source
                    srcSet="https://cleanhome-web.cleaninglab.co.kr/brandsite/about/webp/policy_card_mobile.webp"
                    type="image/webp"
                    media={`(max-width:${BrandSitesV2Theme.brandSitesV2!.breakpoints.mobile})`}
                  />
                  <source
                    srcSet="https://cleanhome-web.cleaninglab.co.kr/brandsite/about/webp/policy_card.webp"
                    type="image/webp"
                  />
                  <source
                    srcSet="https://cleanhome-web.cleaninglab.co.kr/brandsite/about/policy_card_mobile.png"
                    type="image/png"
                    media={`(max-width:${BrandSitesV2Theme.brandSitesV2!.breakpoints.mobile})`}
                  />
                  <source
                    srcSet="https://cleanhome-web.cleaninglab.co.kr/brandsite/about/policy_card.png"
                    type="image/png"
                  />
                  <CardBackgroundImgMotion
                    CardBackgroundImage={CardBackgroundImage}
                    src="https://cleanhome-web.cleaninglab.co.kr/brandsite/about/policy_card.png"
                  />
                </picture>
                <CardBlur />
              </CardBackground>
              <CardFront>
                <CardTop>
                  <CardTeam>정책기획팀</CardTeam>
                  <CardTitle>고객, 매니저 모두 놓치지 않는 청연의 관제탑</CardTitle>
                  <CardDescription>
                    수요와 공급이 적절한지를 분석하고 지역 특수성을 파악하면서 서비스 매칭을 위해 다각도로 분석하고
                    고민해요. 정기 서비스 매칭율을 높이는것도 주요 과제중 하나입니다
                    <DescriptionViewMore>... 더보기</DescriptionViewMore>
                  </CardDescription>
                </CardTop>
                <PlusButton>{PlusSvg}</PlusButton>
              </CardFront>
            </PolicyCard>
          </Link>
          <Link href="https://cleaninglab-official.notion.site/1a4d83ff603049b6a9fe69c5ff658f68" passHref>
            <BusinessCard target="_blank">
              <CardBackground>
                <picture>
                  <source
                    srcSet="https://cleanhome-web.cleaninglab.co.kr/brandsite/about/webp/business_card_mobile.webp"
                    type="image/webp"
                    media={`(max-width:${BrandSitesV2Theme.brandSitesV2!.breakpoints.mobile})`}
                  />
                  <source
                    srcSet="https://cleanhome-web.cleaninglab.co.kr/brandsite/about/webp/business_card.webp"
                    type="image/webp"
                  />
                  <source
                    srcSet="https://cleanhome-web.cleaninglab.co.kr/brandsite/about/business_card_mobile.png"
                    type="image/png"
                    media={`(max-width:${BrandSitesV2Theme.brandSitesV2!.breakpoints.mobile})`}
                  />
                  <source
                    srcSet="https://cleanhome-web.cleaninglab.co.kr/brandsite/about/business_card.png"
                    type="image/png"
                  />
                  <CardBackgroundImgMotion
                    CardBackgroundImage={CardBackgroundImage}
                    src="https://cleanhome-web.cleaninglab.co.kr/brandsite/about/business_card.png"
                  />
                </picture>
                <CardBlur />
              </CardBackground>
              <CardFront>
                <CardTop>
                  <CardTeam>사업개발팀</CardTeam>
                  <CardTitle>
                    청소가 필요한 모든 순간, <br /> 청연이 떠오를 때까지
                  </CardTitle>
                  <CardDescription>
                    여기저기 많은 동네에 청연의 간판을 세우는 일과 같다고 생각해요. 청연의 잠재고객이 있을 곳에 제휴나
                    입점을 통해 유입을 늘리는 것이죠
                    <DescriptionViewMore>... 더보기</DescriptionViewMore>
                  </CardDescription>
                </CardTop>
                <PlusButton>{PlusSvg}</PlusButton>
              </CardFront>
            </BusinessCard>
          </Link>
          <Link href="https://cleaninglab-official.notion.site/fe3892d0c46a46b48a7e57e8a64dd75e" passHref>
            <ServiceCard target="_blank">
              <CardBackground>
                <picture>
                  <source
                    srcSet="https://cleanhome-web.cleaninglab.co.kr/brandsite/about/webp/service_card_mobile.webp"
                    type="image/webp"
                    media={`(max-width:${BrandSitesV2Theme.brandSitesV2!.breakpoints.mobile})`}
                  />
                  <source
                    srcSet="https://cleanhome-web.cleaninglab.co.kr/brandsite/about/webp/service_card.webp"
                    type="image/webp"
                  />
                  <source
                    srcSet="https://cleanhome-web.cleaninglab.co.kr/brandsite/about/service_card_mobile.png"
                    type="image/png"
                    media={`(max-width:${BrandSitesV2Theme.brandSitesV2!.breakpoints.mobile})`}
                  />
                  <source
                    srcSet="https://cleanhome-web.cleaninglab.co.kr/brandsite/about/service_card.png"
                    type="image/png"
                  />
                  <CardBackgroundImgMotion
                    CardBackgroundImage={CardBackgroundImage}
                    src="https://cleanhome-web.cleaninglab.co.kr/brandsite/about/service_card.png"
                  />
                </picture>
                <CardBlur />
              </CardBackground>
              <CardFront>
                <CardTop>
                  <CardTeam>서비스기획팀</CardTeam>
                  <CardTitle>
                    사용자 니즈를 정확히 <br /> 꿰뚫는 제품 만들기
                  </CardTitle>
                  <CardDescription>
                    주요 지표들과 퍼널을 보면서 개선할 수 있는 부분을 찾고 있어요. 말하지 않아도 알아챌 수 있도록,
                    데이터를 보는 데 집중하고 있어요
                    <DescriptionViewMore>... 더보기</DescriptionViewMore>
                  </CardDescription>
                </CardTop>
                <PlusButton>{PlusSvg}</PlusButton>
              </CardFront>
            </ServiceCard>
          </Link>
        </CardGrid>
      </Wrapper>
    </Container>
  );
}

interface CardBackgroundImgMotionProps extends HTMLMotionProps<'img'> {
  CardBackgroundImage: StyledComponent<ForwardRefComponent<HTMLImageElement, HTMLMotionProps<'img'>>, DefaultTheme, {}>;
}

const CardBackgroundImgMotion = ({ CardBackgroundImage, ...props }: CardBackgroundImgMotionProps) => {
  const ref = useRef<HTMLImageElement>(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ['start end', 'end start'],
  });
  const x = useSpring(useTransform(scrollYProgress, [0, 0.4], [8, 0]), {
    stiffness: 600,
    damping: 100,
  });
  const y = useSpring(useTransform(scrollYProgress, [0.6, 1], [0, 10]), {
    stiffness: 600,
    damping: 100,
  });
  const transform = useMotionTemplate`translate(${x}px, ${y}%)`;

  useEffect(() => {
    scrollYProgress.onChange((v) => {
      if (ref.current?.src.includes('education')) {
        // console.log('here progressY', v);
      }
    });
  }, []);

  return <CardBackgroundImage {...props} ref={ref} style={{ transform }} />;
};

const Container = styled.section`
  width: 100%;
  padding: 0 24px;
  padding-top: 120px;
  padding-bottom: 164px;
  position: relative;
  overflow: hidden;

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.tablet}) {
    padding-top: 76px;
    padding-bottom: 84px;
  }

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.mobile}) {
    padding-top: 70px;
    padding-bottom: 66px;
  }
`;

const Wrapper = styled.div`
  position: relative;
  margin: 0 auto;
  max-width: ${({ theme }) => theme.brandSitesV2!.containerWidths!.desktop};

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.tablet}) {
    max-width: ${({ theme }) => theme.brandSitesV2!.containerWidths!.tablet};
  }

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.mobile}) {
    /* max-width: ${({ theme }) => theme.brandSitesV2!.containerWidths!.mobile}; */
  }
`;

const TitleWrapper = styled.div`
  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.mobile}) {
    margin-bottom: 40px;
  }
`;

const FakeTitle = styled.h1`
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  margin: -1px;
  clip: rect(0, 0, 0, 0);
  text-indent: -5000px;
`;

const TitleDesktop = styled.div`
  display: block;

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.tablet}) {
    display: none;
  }
`;

const TitleTablet = styled.div`
  display: none;

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.tablet}) {
    display: block;
  }
`;

const Top = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 114px;

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.tablet}) {
    margin-bottom: 76px;
  }

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.mobile}) {
    flex-direction: column;
    margin-bottom: 44px;
  }
`;

const Description = styled.h2`
  color: rgba(0, 0, 0, 0.6);
  font-weight: 300;
  font-size: 21px;
  line-height: 140%;
  width: 502px;
  letter-spacing: -0.5px;

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.tablet}) {
    font-size: 17px;
    width: 405px;
  }

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.mobile}) {
    width: auto;
    font-weight: 400;
  }
`;

const CardGrid = styled.div`
  width: 100%;
  height: 1140px;
  display: grid;
  gap: 20px;
  grid-template:
    'education policy' 1fr
    'business service' 1fr
    / 1fr 1fr;

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.tablet}) {
    gap: 20px;
    height: 796px;
  }

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.mobile}) {
    gap: 24px;
    height: 1032px;
    grid-template:
      'education' 1fr
      'policy' 1fr
      'business' 1fr
      'service' 1fr
      / 1fr;
  }
`;

const CardBackground = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

const CardBackgroundImage = styled(motion.img)`
  position: absolute;
  bottom: 0;
  right: 0;
  width: calc(100% + 8px);
  height: calc(104%);
  object-fit: cover;

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.mobile}) {
    border-radius: 8px;
  }
`;

const CardBlur = styled.div`
  position: absolute;
  inset: 0;
  transition: 0.2s;

  /* background: rgba(255, 255, 255, 0.75);
  backdrop-filter: blur(20px); */
`;

const CardFront = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  padding: 40px;

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.tablet}) {
    padding: 26px 24px;
  }

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.mobile}) {
    padding: 20px;
  }
`;

const CardTop = styled.div`
  transition: 0.2s;
  position: relative;
  bottom: 0;
`;

const CardTeam = styled.h1`
  font-weight: 500;
  font-size: 21px;
  line-height: 140%;
  color: #227886;
  margin-bottom: 10px;
  transition: 0.2s;

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.tablet}) {
    font-size: 16px;
    margin-bottom: 8px;
  }

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.mobile}) {
    font-size: 14px;
    margin-bottom: 6px;
  }
`;

const CardTitle = styled.h2`
  font-weight: 500;
  font-size: 32px;
  line-height: 140%;
  word-break: keep-all;
  margin-bottom: 24px;

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.tablet}) {
    font-size: 24px;
    margin-bottom: 16px;
  }

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.mobile}) {
    font-weight: 600;
    font-size: 18px;
    width: 200px;
    margin-bottom: 12px;
  }
`;

const CardDescription = styled.p`
  font-weight: 300;
  font-size: 22px;
  line-height: 140%;
  color: rgba(0, 0, 0, 0.85);
  position: relative;
  transition: 0.2s;
  opacity: 0;
  display: none;

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.tablet}) {
    font-size: 18px;
  }

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.mobile}) {
    font-size: 16px;
    font-weight: 400;
  }
`;

const DescriptionViewMore = styled.span`
  white-space: nowrap;
  color: rgba(0, 0, 0, 0.4);
  margin-left: 8px;
`;

const PlusButton = styled.div`
  background: rgba(0, 0, 0, 0);
  border: 1px solid #262626;
  border-radius: 8px;
  padding: 8px;
  width: fit-content;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: 0.2s;

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.mobile}) {
    padding: 4px;
    border-radius: 6px;
  }
`;

const Card = styled(motion.a)`
  display: block;
  border-radius: 16px;
  background: #f5f5f5;
  position: relative;
  overflow: hidden;
  transition: 0.2s;
  backdrop-filter: blur(0);

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.tablet}) {
  }

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.mobile}) {
    border-radius: 8px;
  }

  &:hover {
    ${CardBlur} {
      background: rgba(255, 255, 255, 0.75);
      backdrop-filter: blur(20px);
    }

    ${CardTop} {
      bottom: 8px;
    }

    ${CardTeam} {
      opacity: 0;
    }

    ${CardDescription} {
      display: block;
      opacity: 1;
    }

    ${PlusButton} {
      background: #42484c;

      svg path {
        fill: #ffffff;
      }
    }
  }
`;

const EducationCard = styled(Card)`
  grid-area: education;
`;

const PolicyCard = styled(Card)`
  grid-area: policy;
`;

const BusinessCard = styled(Card)`
  grid-area: business;
`;

const ServiceCard = styled(Card)`
  grid-area: service;
`;

const TitleDesktopSvg = (
  <svg width="396" height="105" viewBox="0 0 396 105" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.174 13.356C1.174 7.56 5.866 2.96 12.352 2.96C18.976 2.96 23.714 7.56 23.714 13.356C23.714 19.29 18.976 23.752 12.352 23.752C5.866 23.752 1.174 19.29 1.174 13.356ZM6.28 13.31C6.28 16.714 8.81 19.382 12.352 19.382C15.894 19.382 18.608 16.714 18.608 13.31C18.608 9.906 15.894 7.376 12.352 7.376C8.81 7.376 6.28 9.906 6.28 13.31ZM36.778 42.75H10.65V27.708H15.802V38.334H36.778V42.75ZM35.904 30.744H30.798V0.705998H35.904V30.744ZM72.3324 6.502V0.705998H77.4844V30.284H72.3324V20.394H61.9364C59.9584 22.786 56.8304 24.212 53.1504 24.212C46.6184 24.212 41.9264 19.704 41.9264 13.632C41.9264 7.698 46.6184 3.052 53.1504 3.052C56.6004 3.052 59.5444 4.386 61.5684 6.502H72.3324ZM78.0824 42.934H52.1844V27.8H57.2904V38.518H78.0824V42.934ZM59.3144 13.586C59.3144 10.09 56.6464 7.514 53.1504 7.514C49.5624 7.514 46.9864 10.09 46.9864 13.586C46.9864 17.082 49.5624 19.796 53.1504 19.796C56.6464 19.796 59.3144 17.082 59.3144 13.586ZM64.3744 13.632C64.3744 14.46 64.2824 15.242 64.1444 15.978H72.3324V11.01H64.0524C64.2364 11.838 64.3744 12.758 64.3744 13.632ZM108.485 9.446C108.485 6.778 105.725 4.708 101.953 4.708C98.0428 4.708 95.4208 6.686 95.4208 9.446C95.4208 12.344 97.9508 14.23 101.953 14.23C105.725 14.23 108.485 12.344 108.485 9.446ZM113.683 9.446C113.683 15.38 107.795 18.462 101.999 18.462C96.1568 18.462 90.1768 15.472 90.1768 9.446C90.1768 3.834 95.7428 0.383997 101.953 0.383997C108.439 0.383997 113.683 3.926 113.683 9.446ZM115.937 44.636H89.1188V33.504H109.773V30.882H89.1188V26.604H114.787V37.69H94.0868V40.358H115.937V44.636ZM121.319 24.074H82.5868V19.704H121.319V24.074ZM137.014 15.058C137.014 8.02 141.89 3.236 148.606 3.236C155.276 3.236 160.198 8.02 160.198 15.058C160.198 22.096 155.276 26.834 148.606 26.834C141.89 26.834 137.014 22.096 137.014 15.058ZM142.212 15.012C142.212 19.474 144.88 22.188 148.606 22.188C152.286 22.188 155 19.474 155 15.012C155 10.55 152.24 7.836 148.606 7.836C144.88 7.836 142.212 10.55 142.212 15.012ZM166.638 39.07V0.751998H171.744V39.07H166.638ZM183.562 15.012C183.562 19.474 186.184 22.188 189.91 22.188C193.636 22.188 196.35 19.474 196.35 15.012C196.35 10.55 193.59 7.836 189.91 7.836C186.23 7.836 183.562 10.55 183.562 15.012ZM178.364 15.058C178.364 8.02 183.24 3.236 189.91 3.236C194.878 3.236 198.972 5.904 200.674 10.274C200.996 11.102 201.226 11.976 201.364 12.85H208.54V0.751998H213.646V39.07H208.54V17.128H201.41C201.272 18.094 200.996 19.014 200.674 19.888C198.926 24.12 194.924 26.834 189.91 26.834C183.24 26.834 178.364 22.096 178.364 15.058ZM259.045 17.588H252.099V39.07H246.993V0.751998H252.099V13.218H259.045V17.588ZM220.773 3.466H240.599C240.599 16.3 233.699 25.362 221.601 30.238L218.749 26.006C228.685 22.326 234.527 15.15 235.125 7.882H220.773V3.466ZM263.549 3.42H283.743C283.697 9.906 281.995 15.38 278.591 19.842C275.187 24.304 270.449 27.754 264.423 30.192L261.479 26.006C271.553 22.326 277.579 15.15 278.177 7.882H263.549V3.42ZM290.735 39.07V0.751998H295.887V39.07H290.735ZM321.196 10.734C321.196 13.448 323.818 15.84 327.268 15.84C330.58 15.84 333.478 13.402 333.294 10.734C333.478 7.744 330.58 5.628 327.268 5.628C323.818 5.628 321.196 7.698 321.196 10.734ZM329.706 39.3H324.6V27.294H324.462C321.058 27.386 317.102 27.478 314.112 27.478L313.56 22.924C314.342 22.97 315.262 22.97 316.366 22.97H319.816C322.254 22.97 324.784 22.878 326.762 22.832C331.5 22.694 338.078 22.096 341.252 21.728L341.62 25.868C339.918 26.19 337.526 26.466 334.996 26.65L331.224 26.926L329.706 27.064V39.3ZM344.104 39.116V0.751998H349.256V39.116H344.104ZM316.182 10.734C316.182 5.444 320.736 1.258 327.268 1.258C333.708 1.258 338.262 5.444 338.262 10.734C338.262 16.07 333.708 20.118 327.268 20.118C320.736 20.118 316.182 16.07 316.182 10.734ZM389.456 43.486H364.018V31.572H369.124V39.116H389.456V43.486ZM379.382 12.436H354.91V8.112H379.382V12.436ZM373.264 5.858H361.534V1.442H373.264V5.858ZM372.022 21.866C372.022 19.796 370.274 18.186 367.514 18.186C364.754 18.186 362.914 19.796 362.914 21.866C362.914 23.936 364.754 25.546 367.514 25.546C370.274 25.546 372.022 23.936 372.022 21.866ZM376.99 21.82C376.99 26.65 372.712 29.548 367.514 29.548C362.132 29.548 357.808 26.65 357.808 21.82C357.808 17.128 362.132 14.046 367.514 14.046C372.85 14.046 376.99 17.128 376.99 21.82ZM395.206 18.094H388.26V32.722H383.2V0.705998H388.26V13.632H395.206V18.094ZM19.298 65.214H6.142V60.844H19.298V65.214ZM30.384 95.804C30.384 92.86 27.808 91.02 23.99 91.02C20.31 91.02 17.688 92.86 17.688 95.804C17.688 98.748 20.31 100.588 23.99 100.588C27.808 100.588 30.384 98.748 30.384 95.804ZM36.088 86.144H30.982V78.14H23.714V73.862H30.982V60.614H36.088V86.144ZM9.96 72.206H1.358V67.882H24.036V72.206H15.71C15.802 73.172 16.032 74.092 16.354 74.874C17.734 78.14 21.138 80.302 25.232 81.406L23.024 85.546C18.976 84.304 14.33 81.314 12.858 78.048C11.432 81.36 7.108 85.04 2.554 86.374L0.162 82.326C4.118 80.808 7.66 78.692 9.224 75.15C9.638 74.276 9.868 73.31 9.96 72.206ZM35.536 95.804C35.536 101.186 30.752 104.958 23.99 104.958C17.366 104.958 12.536 101.186 12.536 95.804C12.536 90.514 17.366 86.696 23.99 86.696C30.752 86.696 35.536 90.514 35.536 95.804ZM72.3324 66.502V60.706H77.4844V90.284H72.3324V80.394H61.9364C59.9584 82.786 56.8304 84.212 53.1504 84.212C46.6184 84.212 41.9264 79.704 41.9264 73.632C41.9264 67.698 46.6184 63.052 53.1504 63.052C56.6004 63.052 59.5444 64.386 61.5684 66.502H72.3324ZM78.0824 102.934H52.1844V87.8H57.2904V98.518H78.0824V102.934ZM59.3144 73.586C59.3144 70.09 56.6464 67.514 53.1504 67.514C49.5624 67.514 46.9864 70.09 46.9864 73.586C46.9864 77.082 49.5624 79.796 53.1504 79.796C56.6464 79.796 59.3144 77.082 59.3144 73.586ZM64.3744 73.632C64.3744 74.46 64.2824 75.242 64.1444 75.978H72.3324V71.01H64.0524C64.2364 71.838 64.3744 72.758 64.3744 73.632ZM89.8548 72.114C89.8548 75.242 92.3848 77.818 95.8348 77.818C99.2848 77.818 101.861 75.242 101.861 72.114C101.861 68.986 99.2848 66.41 95.8348 66.41C92.3848 66.41 89.8548 68.986 89.8548 72.114ZM110.463 85.408L110.831 89.548C107.335 90.146 101.079 90.652 96.7088 90.79C92.7528 91.02 87.0488 91.158 83.0928 91.158L82.5408 86.604H88.7968C91.1888 86.604 93.7188 86.558 95.7428 86.512C100.573 86.374 107.197 85.776 110.463 85.408ZM113.039 99.116V60.752H118.191V99.116H113.039ZM84.7948 72.114C84.7948 66.41 89.4408 62.132 95.8348 62.132C102.275 62.132 107.013 66.41 107.013 72.114C107.013 77.818 102.367 82.096 95.8348 82.096C89.4408 82.096 84.7948 77.818 84.7948 72.114ZM174.688 94.93H135.956V90.606H152.838V81.728H142.396V62.408H147.502V77.312H168.754V81.728H157.852V90.606H174.688V94.93ZM213.646 86.236H208.54V79.06H200.72V74.736H208.54V70.734H200.72V66.456H208.54V60.66H213.646V86.236ZM200.904 79.704L201.41 83.936C195.292 85.224 187.334 85.5 179.1 85.132V71.562H192.532V66.778H179.1V62.454H197.684V75.748H184.206V80.762C188.852 81.13 196.166 80.9 200.904 79.704ZM213.646 104.36H208.54V92.814H188.484V88.444H213.646V104.36Z"
      fill="black"
      fillOpacity="0.85"
    />
  </svg>
);

const TitleTabletSvg = (
  <svg width="233" height="62" viewBox="0 0 233 62" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0.863 8.122C0.863 4.72 3.617 2.02 7.424 2.02C11.312 2.02 14.093 4.72 14.093 8.122C14.093 11.605 11.312 14.224 7.424 14.224C3.617 14.224 0.863 11.605 0.863 8.122ZM3.86 8.095C3.86 10.093 5.345 11.659 7.424 11.659C9.503 11.659 11.096 10.093 11.096 8.095C11.096 6.097 9.503 4.612 7.424 4.612C5.345 4.612 3.86 6.097 3.86 8.095ZM21.761 25.375H6.425V16.546H9.449V22.783H21.761V25.375ZM21.248 18.328H18.251V0.696999H21.248V18.328ZM42.6299 4.099V0.696999H45.6539V18.058H42.6299V12.253H36.5279C35.3669 13.657 33.5309 14.494 31.3709 14.494C27.5369 14.494 24.7829 11.848 24.7829 8.284C24.7829 4.801 27.5369 2.074 31.3709 2.074C33.3959 2.074 35.1239 2.857 36.3119 4.099H42.6299ZM46.0049 25.483H30.8039V16.6H33.8009V22.891H46.0049V25.483ZM34.9889 8.257C34.9889 6.205 33.4229 4.693 31.3709 4.693C29.2649 4.693 27.7529 6.205 27.7529 8.257C27.7529 10.309 29.2649 11.902 31.3709 11.902C33.4229 11.902 34.9889 10.309 34.9889 8.257ZM37.9589 8.284C37.9589 8.77 37.9049 9.229 37.8239 9.661H42.6299V6.745H37.7699C37.8779 7.231 37.9589 7.771 37.9589 8.284ZM63.8498 5.827C63.8498 4.261 62.2298 3.046 60.0158 3.046C57.7208 3.046 56.1818 4.207 56.1818 5.827C56.1818 7.528 57.6668 8.635 60.0158 8.635C62.2298 8.635 63.8498 7.528 63.8498 5.827ZM66.9008 5.827C66.9008 9.31 63.4448 11.119 60.0428 11.119C56.6138 11.119 53.1038 9.364 53.1038 5.827C53.1038 2.533 56.3708 0.507998 60.0158 0.507998C63.8228 0.507998 66.9008 2.587 66.9008 5.827ZM68.2238 26.482H52.4828V19.948H64.6058V18.409H52.4828V15.898H67.5488V22.405H55.3988V23.971H68.2238V26.482ZM71.3828 14.413H48.6488V11.848H71.3828V14.413ZM80.5951 9.121C80.5951 4.99 83.4571 2.182 87.3991 2.182C91.3141 2.182 94.2031 4.99 94.2031 9.121C94.2031 13.252 91.3141 16.033 87.3991 16.033C83.4571 16.033 80.5951 13.252 80.5951 9.121ZM83.6461 9.094C83.6461 11.713 85.2121 13.306 87.3991 13.306C89.5591 13.306 91.1521 11.713 91.1521 9.094C91.1521 6.475 89.5321 4.882 87.3991 4.882C85.2121 4.882 83.6461 6.475 83.6461 9.094ZM97.9831 23.215V0.723999H100.98V23.215H97.9831ZM107.917 9.094C107.917 11.713 109.456 13.306 111.643 13.306C113.83 13.306 115.423 11.713 115.423 9.094C115.423 6.475 113.803 4.882 111.643 4.882C109.483 4.882 107.917 6.475 107.917 9.094ZM104.866 9.121C104.866 4.99 107.728 2.182 111.643 2.182C114.559 2.182 116.962 3.748 117.961 6.313C118.15 6.799 118.285 7.312 118.366 7.825H122.578V0.723999H125.575V23.215H122.578V10.336H118.393C118.312 10.903 118.15 11.443 117.961 11.956C116.935 14.44 114.586 16.033 111.643 16.033C107.728 16.033 104.866 13.252 104.866 9.121ZM152.222 10.606H148.145V23.215H145.148V0.723999H148.145V8.041H152.222V10.606ZM129.758 2.317H141.395C141.395 9.85 137.345 15.169 130.244 18.031L128.57 15.547C134.402 13.387 137.831 9.175 138.182 4.909H129.758V2.317ZM154.866 2.29H166.719C166.692 6.097 165.693 9.31 163.695 11.929C161.697 14.548 158.916 16.573 155.379 18.004L153.651 15.547C159.564 13.387 163.101 9.175 163.452 4.909H154.866V2.29ZM170.823 23.215V0.723999H173.847V23.215H170.823ZM188.702 6.583C188.702 8.176 190.241 9.58 192.266 9.58C194.21 9.58 195.911 8.149 195.803 6.583C195.911 4.828 194.21 3.586 192.266 3.586C190.241 3.586 188.702 4.801 188.702 6.583ZM193.697 23.35H190.7V16.303H190.619C188.621 16.357 186.299 16.411 184.544 16.411L184.22 13.738C184.679 13.765 185.219 13.765 185.867 13.765H187.892C189.323 13.765 190.808 13.711 191.969 13.684C194.75 13.603 198.611 13.252 200.474 13.036L200.69 15.466C199.691 15.655 198.287 15.817 196.802 15.925L194.588 16.087L193.697 16.168V23.35ZM202.148 23.242V0.723999H205.172V23.242H202.148ZM185.759 6.583C185.759 3.478 188.432 1.021 192.266 1.021C196.046 1.021 198.719 3.478 198.719 6.583C198.719 9.715 196.046 12.091 192.266 12.091C188.432 12.091 185.759 9.715 185.759 6.583ZM228.768 25.807H213.837V18.814H216.834V23.242H228.768V25.807ZM222.855 7.582H208.491V5.044H222.855V7.582ZM219.264 3.721H212.379V1.129H219.264V3.721ZM218.535 13.117C218.535 11.902 217.509 10.957 215.889 10.957C214.269 10.957 213.189 11.902 213.189 13.117C213.189 14.332 214.269 15.277 215.889 15.277C217.509 15.277 218.535 14.332 218.535 13.117ZM221.451 13.09C221.451 15.925 218.94 17.626 215.889 17.626C212.73 17.626 210.192 15.925 210.192 13.09C210.192 10.336 212.73 8.527 215.889 8.527C219.021 8.527 221.451 10.336 221.451 13.09ZM232.143 10.903H228.066V19.489H225.096V0.696999H228.066V8.284H232.143V10.903ZM11.501 38.343H3.779V35.778H11.501V38.343ZM18.008 56.298C18.008 54.57 16.496 53.49 14.255 53.49C12.095 53.49 10.556 54.57 10.556 56.298C10.556 58.026 12.095 59.106 14.255 59.106C16.496 59.106 18.008 58.026 18.008 56.298ZM21.356 50.628H18.359V45.93H14.093V43.419H18.359V35.643H21.356V50.628ZM6.02 42.447H0.971V39.909H14.282V42.447H9.395C9.449 43.014 9.584 43.554 9.773 44.013C10.583 45.93 12.581 47.199 14.984 47.847L13.688 50.277C11.312 49.548 8.585 47.793 7.721 45.876C6.884 47.82 4.346 49.98 1.673 50.763L0.269 48.387C2.591 47.496 4.67 46.254 5.588 44.175C5.831 43.662 5.966 43.095 6.02 42.447ZM21.032 56.298C21.032 59.457 18.224 61.671 14.255 61.671C10.367 61.671 7.532 59.457 7.532 56.298C7.532 53.193 10.367 50.952 14.255 50.952C18.224 50.952 21.032 53.193 21.032 56.298ZM42.6299 39.099V35.697H45.6539V53.058H42.6299V47.253H36.5279C35.3669 48.657 33.5309 49.494 31.3709 49.494C27.5369 49.494 24.7829 46.848 24.7829 43.284C24.7829 39.801 27.5369 37.074 31.3709 37.074C33.3959 37.074 35.1239 37.857 36.3119 39.099H42.6299ZM46.0049 60.483H30.8039V51.6H33.8009V57.891H46.0049V60.483ZM34.9889 43.257C34.9889 41.205 33.4229 39.693 31.3709 39.693C29.2649 39.693 27.7529 41.205 27.7529 43.257C27.7529 45.309 29.2649 46.902 31.3709 46.902C33.4229 46.902 34.9889 45.309 34.9889 43.257ZM37.9589 43.284C37.9589 43.77 37.9049 44.229 37.8239 44.661H42.6299V41.745H37.7699C37.8779 42.231 37.9589 42.771 37.9589 43.284ZM52.9148 42.393C52.9148 44.229 54.3998 45.741 56.4248 45.741C58.4498 45.741 59.9618 44.229 59.9618 42.393C59.9618 40.557 58.4498 39.045 56.4248 39.045C54.3998 39.045 52.9148 40.557 52.9148 42.393ZM65.0108 50.196L65.2268 52.626C63.1748 52.977 59.5028 53.274 56.9378 53.355C54.6158 53.49 51.2678 53.571 48.9458 53.571L48.6218 50.898H52.2938C53.6978 50.898 55.1828 50.871 56.3708 50.844C59.2058 50.763 63.0938 50.412 65.0108 50.196ZM66.5228 58.242V35.724H69.5468V58.242H66.5228ZM49.9448 42.393C49.9448 39.045 52.6718 36.534 56.4248 36.534C60.2048 36.534 62.9858 39.045 62.9858 42.393C62.9858 45.741 60.2588 48.252 56.4248 48.252C52.6718 48.252 49.9448 45.741 49.9448 42.393ZM102.708 55.785H79.9741V53.247H89.8831V48.036H83.7541V36.696H86.7511V45.444H99.2251V48.036H92.8261V53.247H102.708V55.785ZM125.575 50.682H122.578V46.47H117.988V43.932H122.578V41.583H117.988V39.072H122.578V35.67H125.575V50.682ZM118.096 46.848L118.393 49.332C114.802 50.088 110.131 50.25 105.298 50.034V42.069H113.182V39.261H105.298V36.723H116.206V44.526H108.295V47.469C111.022 47.685 115.315 47.55 118.096 46.848ZM125.575 61.32H122.578V54.543H110.806V51.978H125.575V61.32Z"
      fill="black"
      fillOpacity="0.85"
    />
  </svg>
);

const PlusSvg = (
  <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.23789 2.2C9.23789 1.8134 8.92449 1.5 8.53789 1.5C8.15129 1.5 7.83789 1.8134 7.83789 2.2V7.35H2.78789C2.40129 7.35 2.08789 7.6634 2.08789 8.05C2.08789 8.4366 2.40129 8.75 2.78789 8.75H7.83789V13.8C7.83789 14.1866 8.15129 14.5 8.53789 14.5C8.92449 14.5 9.23789 14.1866 9.23789 13.8V8.75H14.3879C14.7745 8.75 15.0879 8.4366 15.0879 8.05C15.0879 7.6634 14.7745 7.35 14.3879 7.35H9.23789V2.2Z"
      fill="black"
      fillOpacity="0.85"
    />
  </svg>
);
